import styled from '@emotion/styled'
import { Flex } from 'rebass'
import { position, zIndex } from 'styled-system'

export default styled(Flex)(
  position,
  zIndex,
)
